import { useMyAssignments } from "src/api/hooks/useAssignment";
import useMyUser from "src/api/hooks/useMyUser";
import { Button } from "src/components/Buttons/Button";
import { useNavigate } from "react-router-dom";
import { routes } from "src/routes";

export function StartPage() {
  const assignments = useMyAssignments();
  const {data: myUser} = useMyUser();
  const nav = useNavigate();
  return <div className="h-full w-full flex flex-col items-center align-middle justify-center gap-4">
  {myUser?.groups?.map((group) => (
    <Button key={group.id} title={group.name} onClick={() => {
      nav(routes.Egenkontroller.Pages.List.url(myUser?.companyId));
    }} />
  ))}
  </div>;
}
